import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiComponent } from './ai.component';
import { AiModules, AiPages, Modules } from '../core/constants/shared.constants';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  {
    path: 'overview',
    component: AiComponent,
    loadChildren: () => import('../ai/dashboard/dashboard.module').then(mod => mod.DashboardModule),
    data: {
      module: Modules.Ai,
      menuTitle: Modules.Dashboard
    }
  },
  {
    path: AiPages.BotPrediction,
    component: AiComponent,
    loadChildren: () => import('../ai/bot-prediction/bot-prediction.module').then(mod => mod.BotPredictionModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.BotPrediction
    }
  },
  {
    path: AiPages.Intents,
    component: AiComponent,
    loadChildren: () => import('../ai/intent/intent.module').then(mod => mod.IntentModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.Intents
    }
  },
  {
    path: AiPages.Entity,
    component: AiComponent,
    loadChildren: () => import('../ai/entities/entities.module').then(mod => mod.EntitiesModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.Entity
    }
  },
  {
    path: AiPages.Publish,
    component: AiComponent,
    loadChildren: () => import('../ai/publish-bot/publish-bot.module').then(mod => mod.PublishBotModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.Publish
    }
  },
  {
    path: AiPages.Chatbot,
    component: AiComponent,
    loadChildren: () => import('../ai/chat-bot/chat-bot.module').then(mod => mod.ChatBotModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.Chatbot
    }
  },
  {
    path: AiPages.RephraseInstructions,
    component: AiComponent,
    loadChildren: () => import('../ai/rephrase-instructions/rephrase-instructions.module').then(mod => mod.RephraseInstructionsModule),
    data: {
      module: Modules.Ai,
      menuTitle: AiModules.RephraseInstructions
    }
  },
  {
    path: '',
    redirectTo: 'overview'
  },
  {
    path: '**',
    redirectTo: 'overview'
  }
]

@NgModule({
  declarations: [AiComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class AiRoutingModule { }
